module.exports = __webpack_public_path__ + "flyer_background_ocean_005-0ae1bd23391bafb75aa06d10f1190c75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_ocean_005.jpg
// module id = 1666
// module chunks = 1